export const AGENCY_DRIVER_TYPE = "A";
export const COURIER_DRIVER_TYPE = "C";
export const ODF_DRIVER_TYPE = "O";
export const DR_DRIVER_TYPE = "D";
export const EMPLOYED_DRIVER_TYPE = "E";
export const EMPLOYED_7_5T_DRIVER_TYPE = "H";
export const CHOICE_DRIVER_TYPE = "I";
export const HOME_COURIER_DRIVER_TYPE = "R";
export const ROBOT_DRIVER_TYPE = "B";

export const DRIVER_TYPE_NAMES = {
  [AGENCY_DRIVER_TYPE]: "Agency",
  [COURIER_DRIVER_TYPE]: "Courier",
  [ODF_DRIVER_TYPE]: "ODF",
  [DR_DRIVER_TYPE]: "ODF Driver",
  [EMPLOYED_DRIVER_TYPE]: "Employed",
  [EMPLOYED_7_5T_DRIVER_TYPE]: "Employed 7.5T",
  [CHOICE_DRIVER_TYPE]: "Connect",
  [HOME_COURIER_DRIVER_TYPE]: "Home Courier",
  [ROBOT_DRIVER_TYPE]: "Robot",
};

export const DRIVER_TYPES_BY_NAME = {
  [DRIVER_TYPE_NAMES[AGENCY_DRIVER_TYPE]]: AGENCY_DRIVER_TYPE,
  [DRIVER_TYPE_NAMES[COURIER_DRIVER_TYPE]]: COURIER_DRIVER_TYPE,
  [DRIVER_TYPE_NAMES[ODF_DRIVER_TYPE]]: ODF_DRIVER_TYPE,
  [DRIVER_TYPE_NAMES[DR_DRIVER_TYPE]]: DR_DRIVER_TYPE,
  [DRIVER_TYPE_NAMES[EMPLOYED_DRIVER_TYPE]]: EMPLOYED_DRIVER_TYPE,
  [DRIVER_TYPE_NAMES[EMPLOYED_7_5T_DRIVER_TYPE]]: EMPLOYED_7_5T_DRIVER_TYPE,
  [DRIVER_TYPE_NAMES[CHOICE_DRIVER_TYPE]]: CHOICE_DRIVER_TYPE,
  [DRIVER_TYPE_NAMES[HOME_COURIER_DRIVER_TYPE]]: HOME_COURIER_DRIVER_TYPE,
  [DRIVER_TYPE_NAMES[ROBOT_DRIVER_TYPE]]: ROBOT_DRIVER_TYPE,
};

export const EMPLOYED_DRIVER_TYPES = {
  [EMPLOYED_DRIVER_TYPE]: DRIVER_TYPE_NAMES[EMPLOYED_DRIVER_TYPE],
  [EMPLOYED_7_5T_DRIVER_TYPE]: DRIVER_TYPE_NAMES[EMPLOYED_7_5T_DRIVER_TYPE],
};

export const CONTRACTOR_DRIVER_TYPES = {
  [AGENCY_DRIVER_TYPE]: DRIVER_TYPE_NAMES[AGENCY_DRIVER_TYPE],
  [COURIER_DRIVER_TYPE]: DRIVER_TYPE_NAMES[COURIER_DRIVER_TYPE],
  [HOME_COURIER_DRIVER_TYPE]: DRIVER_TYPE_NAMES[HOME_COURIER_DRIVER_TYPE],
};

export const NON_ODF_DRIVER_TYPES = {
  ...EMPLOYED_DRIVER_TYPES,
  ...CONTRACTOR_DRIVER_TYPES,
};
